<template>
  <v-dialog v-model="modal" width="640px">
    <v-card>
      <v-card-title>{{ $t('messenger.actions.fileupload.title') }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <file-input  v-model="file" :config="{
          label: $t('messenger.actions.fileupload.labels.file'),
          path: 'chat'
        }"></file-input>
        <span class="caption">{{ filename }}</span>
      </v-card-text>
      <v-card-row actions>
        <v-btn :disabled="!file" :loading="loading" primary light @click.native.stop="submit()">{{ $t('messenger.actions.fileupload.submit') }}</v-btn>
      </v-card-row>
    </v-card>
  </v-dialog>
</template>

<script>
  import chatMessage from '@/mixins/chatMessage'
  import autoOpenModal from '@/mixins/autoOpenModal'
  import { FileInput } from '@/components/inputs'
  export default {
    components: {
      FileInput
    },
    mixins: [
      autoOpenModal,
      chatMessage
    ],
    data () {
      return {
        file: null
      }
    },
    computed: {
      filename () {
        if (!this.file) { return null }
        return this.file.split('/').reverse()[0]
      }
    },
    methods: {
      submit () {
        this.send({
          content: this.file,
          data: {
            type: 'file',
            url: this.file
          }
        })
          .then(_ => this.close())
      }
    }
  }
</script>

<style lang="stylus" scoped>
  $stepper-height := 480px;
  $stepper-header-height := 72px;

  .stepper {
    height: $stepper-height;
  }

  .stepper__content {
    height: $stepper-height - $stepper-header-height;
    overflow: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/messenger/actions/FileUpload.vue